import InsightsCard from "features/Research/v2/components/StockDetailPage/InsightsCard/index";
import { CardsGrid } from "features/Research/v2/components/StocksInsight/StocksInsight";
import React from "react";
import PropTypes from "prop-types";
import { useSimilarStrategies } from "features/Strategy/hook/useSimilarStrategies";
import { SkeletonCard } from "./SimilarStrategies.styles";
import { useNavigation } from "utils/navigate";

const SimilarStrategies = ({ strategyId }) => {
  const { data: similarStrategies, isLoading } =
    useSimilarStrategies(strategyId);
  const { navigateToV2StrategyDetail } = useNavigation();

  const transformedData = similarStrategies.map((strategy) => ({
    id: strategy.strategy_id,
    imageUrl: strategy.cover_photo,
    isRecommended: false,
    subtitle: strategy.author_name,
    title: strategy.name,
    tags: {
      type:
        strategy.key_stats?.find((item) => item.name === "Asset Classes")
          ?.value || "strategy",
      investors: strategy.investors?.formatted || "--",
      investment: strategy.investment?.formatted || "$--",
    },
  }));

  if (isLoading) {
    return (
      <CardsGrid>
        {[1, 2].map((index) => (
          <SkeletonCard key={index} />
        ))}
      </CardsGrid>
    );
  }

  return (
    <CardsGrid>
      {transformedData.map((item, i) => (
        <div
          onClick={() => navigateToV2StrategyDetail(item.id)}
          key={`${item.title}-${i}`}
        >
          <InsightsCard
            imageUrl={item.imageUrl}
            isRecommended={item.isRecommended}
            subtitle={item.subtitle}
            title={item.title}
            tags={item.tags}
          />
        </div>
      ))}
    </CardsGrid>
  );
};

SimilarStrategies.propTypes = {
  strategyId: PropTypes.string.isRequired,
};

export default SimilarStrategies;
